import React, { useMemo, useState } from "react";
import {
  FileSpreadsheet, History, ClipboardList, Inbox, BookOpen, Sparkles,
} from "lucide-react";
import CirGeneratorPanel from "./CirGeneratorPanel";
import CirHistoryPanel from "./CirHistoryPanel";
import KaiQuestionnairesTab from "./KaiQuestionnairesTab";
import KaiTrayTab from "./KaiTrayTab";
import KaiLibraryPanel from "./KaiLibraryPanel";
import PlannerTab from "./PlannerTab";

// V1.31 · Workspace de KAI. Agrupa todas las herramientas del agente KAI
// en un único espacio con sub-navegación horizontal.
const SECTIONS = [
  { key: "cir_generate", label: "Generar CIR",   icon: FileSpreadsheet, component: CirGeneratorPanel },
  { key: "cir_history",  label: "Historial CIR", icon: History,         component: CirHistoryPanel },
  { key: "cuestionarios", label: "Cuestionarios", icon: ClipboardList,  component: KaiQuestionnairesTab },
  { key: "bandeja",      label: "Bandeja",       icon: Inbox,           component: KaiTrayTab },
  { key: "biblioteca",   label: "Biblioteca",    icon: BookOpen,        component: KaiLibraryPanel },
  { key: "planificador", label: "Kai Planificador", icon: Sparkles,      component: PlannerTab },
];

export default function KaiWorkspace({ initialSection }) {
  const [section, setSection] = useState(initialSection || "cir_generate");
  const Active = useMemo(
    () => (SECTIONS.find((s) => s.key === section) || SECTIONS[0]).component,
    [section]
  );

  return (
    <div className="space-y-4" data-testid="kai-workspace">
      {/* Header workspace */}
      <div className="rounded-2xl border-2 border-orange-200 bg-gradient-to-br from-orange-50 to-amber-50 p-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-orange-500 text-white flex items-center justify-center shadow-sm">
            <Sparkles className="h-5 w-5" />
          </div>
          <div>
            <div className="text-lg font-bold text-neutral-900">KAI · Agente Operativo</div>
            <div className="text-xs text-neutral-600">Gestión documental, exámenes, cuestionarios y automatizaciones internas.</div>
          </div>
        </div>
      </div>

      {/* Sub-nav horizontal */}
      <div className="card-surface p-1 flex flex-wrap gap-1" data-testid="kai-workspace-subnav">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          const active = s.key === section;
          return (
            <button
              key={s.key}
              onClick={() => setSection(s.key)}
              data-testid={`kai-subnav-${s.key}`}
              className={
                "inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors " +
                (active
                  ? "bg-orange-500 text-white shadow-sm"
                  : "text-neutral-700 hover:bg-orange-50")
              }
            >
              <Icon className="h-4 w-4" />
              <span>{s.label}</span>
            </button>
          );
        })}
      </div>

      {/* Contenido */}
      <div>
        <Active />
      </div>
    </div>
  );
}
